module.exports = __webpack_public_path__ + "static/assets/6893f50b7ab4ba84d6a36df3f86bd7f4.png";